/** Contact-enquiry evidence only; never payment evidence or analytics parameters. */
export function courseEnquiryAttribution(pathname: string, search: string, referrer = ''): string {
  if (pathname !== '/intensive-driving-courses-cheltenham') return '';
  const params = new URLSearchParams(search);
  const clean = (value: string) => value.replace(/[\r\n<>]/g, '').slice(0, 120);
  const campaign = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid']
    .flatMap(key => params.get(key) ? [`${key}: ${clean(params.get(key) || '')}`] : []);
  let source = 'Direct / unknown';
  const medium = params.get('utm_medium')?.toLowerCase();
  if (params.has('gclid') || (params.get('utm_source')?.toLowerCase() === 'google' && ['cpc', 'ppc', 'paidsearch'].includes(medium || ''))) source = 'Google Ads';
  else if (medium === 'organic') source = 'Organic search';
  else if (params.has('utm_source')) source = 'Tagged campaign';
  else {
    try {
      const host = new URL(referrer).hostname;
      if (/(^|\.)(google\.[a-z.]+|bing\.com|duckduckgo\.com)$/.test(host)) source = 'Organic search';
      else if (host && host !== 'best-drive.co.uk') source = 'Referral';
    } catch { /* Missing referrer is not proof of organic traffic. */ }
  }
  return [`Landing page: https://best-drive.co.uk${pathname}`, `Enquiry origin: Cheltenham · ${source}`, ...campaign].join('\n');
}